import { useMutation } from "@apollo/client";
import isEmpty from "lodash/isEmpty";
import { useContextSelector } from "use-context-selector";
import FileUnitRadioGroup from "./FileUnitRadioGroup";
import {
  PatchFileUnitOfMeasurementQuery,
  PfsFile,
  UnitOfMeasurement,
} from "../../schema/generated/schema";
import { usePfsClient } from "../../apollo";
import { graphqlErrorToMessage } from "../../utils/graphqlErrorHandler";
import { JsonSchemaActionContext } from "../JsonSchemaLoftTheme/JsonSchemaDataContext";

type FileUnitFieldProps = {
  file: PfsFile;
};

const FileUnitField = ({ file }: FileUnitFieldProps) => {
  const pfsClient = usePfsClient();
  const selectedUnitOfMeasurement =
    file.contextMeta?.geometry?.unitOfMeasurement || UnitOfMeasurement.Mm;

  const refetch = useContextSelector(
    JsonSchemaActionContext,
    context => context.actions?.refetch
  );

  const [updateUnitOfMeasurement] = useMutation(
    PatchFileUnitOfMeasurementQuery,
    {
      client: pfsClient,
      onError: error => {
        console.error(
          graphqlErrorToMessage("There was an error while changing file", error)
        );
      },
      onCompleted: () => refetch?.(),
    }
  );

  if (isEmpty(file)) {
    return null;
  }

  const handleUpdateUnits = async (unit: UnitOfMeasurement) => {
    updateUnitOfMeasurement({
      variables: { fileId: file.id, unit },
    });
  };

  return (
    <FileUnitRadioGroup
      name={file.id}
      defaultValue={selectedUnitOfMeasurement}
      onChange={handleUpdateUnits}
    />
  );
};

export default FileUnitField;
